/**
 * ------------------------------------------------------------------------------
 * <auto-generated>
 *     This code was generated by a tool.
 *     Changes to this file may cause incorrect behavior and will be lost if
 *     the code is regenerated.
 * </auto-generated>
 * ------------------------------------------------------------------------------
 */

export const NAME = "cosmopolitan";
export const FONT_FAMILY = "'Noto Sans', sans-serif";
export const LAYOUT_RADIUS = "3px";
export const LAYOUT_SPACE = "8px";
export const LAYOUT_THICKNESS = "1px";
export const SCHEME_LIGHT_SURFACE = "#fefefe";
export const SCHEME_LIGHT_CONTRAST = "#ffffff";
export const SCHEME_LIGHT_BACKGROUND = "#ffffff";
export const SCHEME_LIGHT_FOREGROUND = "#000000";
export const SCHEME_LIGHT_HIGHLIGHT = "#e2e2e2";
export const SCHEME_LIGHT_MIDDLELIGHT = "#777777";
export const SCHEME_LIGHT_LOWLIGHT = "#4d4d4d";
export const SCHEME_LIGHT_TRANSPARENT = "rgba(255, 255, 255, 0)";
export const SCHEME_LIGHT_SEMI_TRANSPARENT = "rgba(255, 255, 255, 0.67)";
export const SCHEME_LIGHT_DISABLED = "#b8b5b2";
export const SCHEME_LIGHT_SELECTION = "#ffaad4";
export const SCHEME_DARK_SURFACE = "#2e2d2d";
export const SCHEME_DARK_CONTRAST = "#ffffff";
export const SCHEME_DARK_BACKGROUND = "#2e2d2d";
export const SCHEME_DARK_FOREGROUND = "#ffffff";
export const SCHEME_DARK_HIGHLIGHT = "#333333";
export const SCHEME_DARK_MIDDLELIGHT = "#666666";
export const SCHEME_DARK_LOWLIGHT = "#999999";
export const SCHEME_DARK_TRANSPARENT = "rgba(23, 23, 23, 0)";
export const SCHEME_DARK_SEMI_TRANSPARENT = "rgba(23, 23, 23, 0.67)";
export const SCHEME_DARK_DISABLED = "#5c5956";
export const SCHEME_DARK_SELECTION = "#ff66aa";
export const COLOR_LIGHT_PRIMARY_0 = "#ffffff";
export const COLOR_LIGHT_PRIMARY_50 = "#fce4ec";
export const COLOR_LIGHT_PRIMARY_100 = "#f8bcd0";
export const COLOR_LIGHT_PRIMARY_200 = "#f48fb1";
export const COLOR_LIGHT_PRIMARY_300 = "#f06292";
export const COLOR_LIGHT_PRIMARY_400 = "#ec407a";
export const COLOR_LIGHT_PRIMARY_500 = "#e91e63";
export const COLOR_LIGHT_PRIMARY_600 = "#cb1a56";
export const COLOR_LIGHT_PRIMARY_700 = "#a31545";
export const COLOR_LIGHT_PRIMARY_800 = "#7e1035";
export const COLOR_LIGHT_PRIMARY_900 = "#3a0819";
export const COLOR_LIGHT_SECONDARY_0 = "#ffffff";
export const COLOR_LIGHT_SECONDARY_50 = "#e6f6e9";
export const COLOR_LIGHT_SECONDARY_100 = "#c3e8c9";
export const COLOR_LIGHT_SECONDARY_200 = "#9bd9a7";
export const COLOR_LIGHT_SECONDARY_300 = "#70cb83";
export const COLOR_LIGHT_SECONDARY_400 = "#4dbf68";
export const COLOR_LIGHT_SECONDARY_500 = "#21b34d";
export const COLOR_LIGHT_SECONDARY_600 = "#16a444";
export const COLOR_LIGHT_SECONDARY_700 = "#009238";
export const COLOR_LIGHT_SECONDARY_800 = "#00812d";
export const COLOR_LIGHT_SECONDARY_900 = "#006218";
export const COLOR_LIGHT_TERTIARY_0 = "#ffffff";
export const COLOR_LIGHT_TERTIARY_50 = "#e1f5fc";
export const COLOR_LIGHT_TERTIARY_100 = "#b4e6f7";
export const COLOR_LIGHT_TERTIARY_200 = "#84d5f3";
export const COLOR_LIGHT_TERTIARY_300 = "#56c5ee";
export const COLOR_LIGHT_TERTIARY_400 = "#35b8eb";
export const COLOR_LIGHT_TERTIARY_500 = "#19ace9";
export const COLOR_LIGHT_TERTIARY_600 = "#139edb";
export const COLOR_LIGHT_TERTIARY_700 = "#098bc7";
export const COLOR_LIGHT_TERTIARY_800 = "#087ab4";
export const COLOR_LIGHT_TERTIARY_900 = "#005a92";
export const COLOR_LIGHT_INFO_0 = "#ffffff";
export const COLOR_LIGHT_INFO_50 = "#f4faff";
export const COLOR_LIGHT_INFO_100 = "#ddf1ff";
export const COLOR_LIGHT_INFO_200 = "#addbff";
export const COLOR_LIGHT_INFO_300 = "#6fb6ff";
export const COLOR_LIGHT_INFO_400 = "#3990ff";
export const COLOR_LIGHT_INFO_500 = "#096bde";
export const COLOR_LIGHT_INFO_600 = "#054da7";
export const COLOR_LIGHT_INFO_700 = "#02367d";
export const COLOR_LIGHT_INFO_800 = "#072859";
export const COLOR_LIGHT_INFO_900 = "#00153c";
export const COLOR_LIGHT_WARNING_0 = "#ffffff";
export const COLOR_LIGHT_WARNING_50 = "#fff8c5";
export const COLOR_LIGHT_WARNING_100 = "#fae17d";
export const COLOR_LIGHT_WARNING_200 = "#eac54f";
export const COLOR_LIGHT_WARNING_300 = "#d4a72c";
export const COLOR_LIGHT_WARNING_400 = "#bf8700";
export const COLOR_LIGHT_WARNING_500 = "#9a6700";
export const COLOR_LIGHT_WARNING_600 = "#7d4e00";
export const COLOR_LIGHT_WARNING_700 = "#633c01";
export const COLOR_LIGHT_WARNING_800 = "#4d2d00";
export const COLOR_LIGHT_WARNING_900 = "#3b2300";
export const COLOR_LIGHT_DANGER_0 = "#ffffff";
export const COLOR_LIGHT_DANGER_50 = "#fff8f6";
export const COLOR_LIGHT_DANGER_100 = "#ffe9e8";
export const COLOR_LIGHT_DANGER_200 = "#ffc7c5";
export const COLOR_LIGHT_DANGER_300 = "#ff9192";
export const COLOR_LIGHT_DANGER_400 = "#fa5255";
export const COLOR_LIGHT_DANGER_500 = "#d3232f";
export const COLOR_LIGHT_DANGER_600 = "#a10e25";
export const COLOR_LIGHT_DANGER_700 = "#77061b";
export const COLOR_LIGHT_DANGER_800 = "#580013";
export const COLOR_LIGHT_DANGER_900 = "#39000d";
export const COLOR_LIGHT_SUCCESS_0 = "#ffffff";
export const COLOR_LIGHT_SUCCESS_50 = "#f3fef5";
export const COLOR_LIGHT_SUCCESS_100 = "#d7f5dd";
export const COLOR_LIGHT_SUCCESS_200 = "#77ec95";
export const COLOR_LIGHT_SUCCESS_300 = "#4cc76e";
export const COLOR_LIGHT_SUCCESS_400 = "#2ca24d";
export const COLOR_LIGHT_SUCCESS_500 = "#1a7d36";
export const COLOR_LIGHT_SUCCESS_600 = "#0f5d26";
export const COLOR_LIGHT_SUCCESS_700 = "#034318";
export const COLOR_LIGHT_SUCCESS_800 = "#002f0f";
export const COLOR_LIGHT_SUCCESS_900 = "#001d09";
export const COLOR_LIGHT_HIGHLIGHT_0 = "#ffffff";
export const COLOR_LIGHT_HIGHLIGHT_50 = "#fdf7ff";
export const COLOR_LIGHT_HIGHLIGHT_100 = "#f4eaff";
export const COLOR_LIGHT_HIGHLIGHT_200 = "#e1cbff";
export const COLOR_LIGHT_HIGHLIGHT_300 = "#c69eff";
export const COLOR_LIGHT_HIGHLIGHT_400 = "#a374f9";
export const COLOR_LIGHT_HIGHLIGHT_500 = "#814dde";
export const COLOR_LIGHT_HIGHLIGHT_600 = "#5f35ae";
export const COLOR_LIGHT_HIGHLIGHT_700 = "#452382";
export const COLOR_LIGHT_HIGHLIGHT_800 = "#301761";
export const COLOR_LIGHT_HIGHLIGHT_900 = "#1d0a42";
export const COLOR_LIGHT_NEUTRAL_0 = "#ffffff";
export const COLOR_LIGHT_NEUTRAL_50 = "#f7f7f8";
export const COLOR_LIGHT_NEUTRAL_100 = "#ebebef";
export const COLOR_LIGHT_NEUTRAL_200 = "#d8d8df";
export const COLOR_LIGHT_NEUTRAL_300 = "#b9b9c6";
export const COLOR_LIGHT_NEUTRAL_400 = "#8f8fa3";
export const COLOR_LIGHT_NEUTRAL_500 = "#73738c";
export const COLOR_LIGHT_NEUTRAL_600 = "#5a5a72";
export const COLOR_LIGHT_NEUTRAL_700 = "#434356";
export const COLOR_LIGHT_NEUTRAL_800 = "#25252d";
export const COLOR_LIGHT_NEUTRAL_900 = "#131318";
export const COLOR_DARK_PRIMARY_0 = "#000000";
export const COLOR_DARK_PRIMARY_50 = "#3a0819";
export const COLOR_DARK_PRIMARY_100 = "#7e1035";
export const COLOR_DARK_PRIMARY_200 = "#a31545";
export const COLOR_DARK_PRIMARY_300 = "#cb1a56";
export const COLOR_DARK_PRIMARY_400 = "#e91e63";
export const COLOR_DARK_PRIMARY_500 = "#ec407a";
export const COLOR_DARK_PRIMARY_600 = "#f06292";
export const COLOR_DARK_PRIMARY_700 = "#f48fb1";
export const COLOR_DARK_PRIMARY_800 = "#f8bcd0";
export const COLOR_DARK_PRIMARY_900 = "#fce4ec";
export const COLOR_DARK_SECONDARY_0 = "#000000";
export const COLOR_DARK_SECONDARY_50 = "#006218";
export const COLOR_DARK_SECONDARY_100 = "#00812d";
export const COLOR_DARK_SECONDARY_200 = "#009238";
export const COLOR_DARK_SECONDARY_300 = "#16a444";
export const COLOR_DARK_SECONDARY_400 = "#21b34d";
export const COLOR_DARK_SECONDARY_500 = "#4dbf68";
export const COLOR_DARK_SECONDARY_600 = "#70cb83";
export const COLOR_DARK_SECONDARY_700 = "#9bd9a7";
export const COLOR_DARK_SECONDARY_800 = "#c3e8c9";
export const COLOR_DARK_SECONDARY_900 = "#e6f6e9";
export const COLOR_DARK_TERTIARY_0 = "#000000";
export const COLOR_DARK_TERTIARY_50 = "#005a92";
export const COLOR_DARK_TERTIARY_100 = "#087ab4";
export const COLOR_DARK_TERTIARY_200 = "#098bc7";
export const COLOR_DARK_TERTIARY_300 = "#139edb";
export const COLOR_DARK_TERTIARY_400 = "#19ace9";
export const COLOR_DARK_TERTIARY_500 = "#35b8eb";
export const COLOR_DARK_TERTIARY_600 = "#56c5ee";
export const COLOR_DARK_TERTIARY_700 = "#84d5f3";
export const COLOR_DARK_TERTIARY_800 = "#b4e6f7";
export const COLOR_DARK_TERTIARY_900 = "#e1f5fc";
export const COLOR_DARK_INFO_0 = "#000000";
export const COLOR_DARK_INFO_50 = "#00153c";
export const COLOR_DARK_INFO_100 = "#072859";
export const COLOR_DARK_INFO_200 = "#02367d";
export const COLOR_DARK_INFO_300 = "#054da7";
export const COLOR_DARK_INFO_400 = "#096bde";
export const COLOR_DARK_INFO_500 = "#3990ff";
export const COLOR_DARK_INFO_600 = "#6fb6ff";
export const COLOR_DARK_INFO_700 = "#addbff";
export const COLOR_DARK_INFO_800 = "#ddf1ff";
export const COLOR_DARK_INFO_900 = "#f4faff";
export const COLOR_DARK_WARNING_0 = "#000000";
export const COLOR_DARK_WARNING_50 = "#3b2300";
export const COLOR_DARK_WARNING_100 = "#4d2d00";
export const COLOR_DARK_WARNING_200 = "#633c01";
export const COLOR_DARK_WARNING_300 = "#7d4e00";
export const COLOR_DARK_WARNING_400 = "#9a6700";
export const COLOR_DARK_WARNING_500 = "#bf8700";
export const COLOR_DARK_WARNING_600 = "#d4a72c";
export const COLOR_DARK_WARNING_700 = "#eac54f";
export const COLOR_DARK_WARNING_800 = "#fae17d";
export const COLOR_DARK_WARNING_900 = "#fff8c5";
export const COLOR_DARK_DANGER_0 = "#000000";
export const COLOR_DARK_DANGER_50 = "#39000d";
export const COLOR_DARK_DANGER_100 = "#580013";
export const COLOR_DARK_DANGER_200 = "#77061b";
export const COLOR_DARK_DANGER_300 = "#a10e25";
export const COLOR_DARK_DANGER_400 = "#d3232f";
export const COLOR_DARK_DANGER_500 = "#fa5255";
export const COLOR_DARK_DANGER_600 = "#ff9192";
export const COLOR_DARK_DANGER_700 = "#ffc7c5";
export const COLOR_DARK_DANGER_800 = "#ffe9e8";
export const COLOR_DARK_DANGER_900 = "#fff8f6";
export const COLOR_DARK_SUCCESS_0 = "#000000";
export const COLOR_DARK_SUCCESS_50 = "#001d09";
export const COLOR_DARK_SUCCESS_100 = "#002f0f";
export const COLOR_DARK_SUCCESS_200 = "#034318";
export const COLOR_DARK_SUCCESS_300 = "#0f5d26";
export const COLOR_DARK_SUCCESS_400 = "#1a7d36";
export const COLOR_DARK_SUCCESS_500 = "#2ca24d";
export const COLOR_DARK_SUCCESS_600 = "#4cc76e";
export const COLOR_DARK_SUCCESS_700 = "#77ec95";
export const COLOR_DARK_SUCCESS_800 = "#d7f5dd";
export const COLOR_DARK_SUCCESS_900 = "#f3fef5";
export const COLOR_DARK_HIGHLIGHT_0 = "#000000";
export const COLOR_DARK_HIGHLIGHT_50 = "#1d0a42";
export const COLOR_DARK_HIGHLIGHT_100 = "#301761";
export const COLOR_DARK_HIGHLIGHT_200 = "#452382";
export const COLOR_DARK_HIGHLIGHT_300 = "#5f35ae";
export const COLOR_DARK_HIGHLIGHT_400 = "#814dde";
export const COLOR_DARK_HIGHLIGHT_500 = "#a374f9";
export const COLOR_DARK_HIGHLIGHT_600 = "#c69eff";
export const COLOR_DARK_HIGHLIGHT_700 = "#e1cbff";
export const COLOR_DARK_HIGHLIGHT_800 = "#f4eaff";
export const COLOR_DARK_HIGHLIGHT_900 = "#fdf7ff";
export const COLOR_DARK_NEUTRAL_0 = "#000000";
export const COLOR_DARK_NEUTRAL_50 = "#131318";
export const COLOR_DARK_NEUTRAL_100 = "#25252d";
export const COLOR_DARK_NEUTRAL_200 = "#434356";
export const COLOR_DARK_NEUTRAL_300 = "#5a5a72";
export const COLOR_DARK_NEUTRAL_400 = "#73738c";
export const COLOR_DARK_NEUTRAL_500 = "#8f8fa3";
export const COLOR_DARK_NEUTRAL_600 = "#b9b9c6";
export const COLOR_DARK_NEUTRAL_700 = "#d8d8df";
export const COLOR_DARK_NEUTRAL_800 = "#ebebef";
export const COLOR_DARK_NEUTRAL_900 = "#f7f7f8";
export const TYPOGRAPHY_HEADLINE1_FONT_FAMILY = "'Noto Sans', sans-serif";
export const TYPOGRAPHY_HEADLINE1_FONT_SIZE = "24px";
export const TYPOGRAPHY_HEADLINE1_LINE_HEIGHT = "28px";
export const TYPOGRAPHY_HEADLINE1_FONT_WEIGHT = "300";
export const TYPOGRAPHY_HEADLINE1_LETTER_SPACING = "-0.25px";
export const TYPOGRAPHY_HEADLINE1_TEXT_DECORATION = "none";
export const TYPOGRAPHY_HEADLINE1_TEXT_TRANSFORM = "none";
export const TYPOGRAPHY_HEADLINE2_FONT_FAMILY = "'Noto Sans', sans-serif";
export const TYPOGRAPHY_HEADLINE2_FONT_SIZE = "24px";
export const TYPOGRAPHY_HEADLINE2_LINE_HEIGHT = "28px";
export const TYPOGRAPHY_HEADLINE2_FONT_WEIGHT = "300";
export const TYPOGRAPHY_HEADLINE2_LETTER_SPACING = "-0.25px";
export const TYPOGRAPHY_HEADLINE2_TEXT_DECORATION = "none";
export const TYPOGRAPHY_HEADLINE2_TEXT_TRANSFORM = "none";
export const TYPOGRAPHY_HEADLINE3_FONT_FAMILY = "'Noto Sans', sans-serif";
export const TYPOGRAPHY_HEADLINE3_FONT_SIZE = "24px";
export const TYPOGRAPHY_HEADLINE3_LINE_HEIGHT = "28px";
export const TYPOGRAPHY_HEADLINE3_FONT_WEIGHT = "300";
export const TYPOGRAPHY_HEADLINE3_LETTER_SPACING = "-0.25px";
export const TYPOGRAPHY_HEADLINE3_TEXT_DECORATION = "none";
export const TYPOGRAPHY_HEADLINE3_TEXT_TRANSFORM = "none";
export const TYPOGRAPHY_HEADLINE4_FONT_FAMILY = "'Noto Sans', sans-serif";
export const TYPOGRAPHY_HEADLINE4_FONT_SIZE = "24px";
export const TYPOGRAPHY_HEADLINE4_LINE_HEIGHT = "28px";
export const TYPOGRAPHY_HEADLINE4_FONT_WEIGHT = "300";
export const TYPOGRAPHY_HEADLINE4_LETTER_SPACING = "-0.25px";
export const TYPOGRAPHY_HEADLINE4_TEXT_DECORATION = "none";
export const TYPOGRAPHY_HEADLINE4_TEXT_TRANSFORM = "none";
export const TYPOGRAPHY_HEADLINE5_FONT_FAMILY = "'Noto Sans', sans-serif";
export const TYPOGRAPHY_HEADLINE5_FONT_SIZE = "24px";
export const TYPOGRAPHY_HEADLINE5_LINE_HEIGHT = "28px";
export const TYPOGRAPHY_HEADLINE5_FONT_WEIGHT = "300";
export const TYPOGRAPHY_HEADLINE5_LETTER_SPACING = "-0.25px";
export const TYPOGRAPHY_HEADLINE5_TEXT_DECORATION = "none";
export const TYPOGRAPHY_HEADLINE5_TEXT_TRANSFORM = "none";
export const TYPOGRAPHY_HEADLINE6_FONT_FAMILY = "'Noto Sans', sans-serif";
export const TYPOGRAPHY_HEADLINE6_FONT_SIZE = "24px";
export const TYPOGRAPHY_HEADLINE6_LINE_HEIGHT = "28px";
export const TYPOGRAPHY_HEADLINE6_FONT_WEIGHT = "300";
export const TYPOGRAPHY_HEADLINE6_LETTER_SPACING = "-0.25px";
export const TYPOGRAPHY_HEADLINE6_TEXT_DECORATION = "none";
export const TYPOGRAPHY_HEADLINE6_TEXT_TRANSFORM = "none";
export const TYPOGRAPHY_BODY1_FONT_FAMILY = "'Noto Sans', sans-serif";
export const TYPOGRAPHY_BODY1_FONT_SIZE = "16px";
export const TYPOGRAPHY_BODY1_LINE_HEIGHT = "20px";
export const TYPOGRAPHY_BODY1_FONT_WEIGHT = "300";
export const TYPOGRAPHY_BODY1_LETTER_SPACING = "-0.25px";
export const TYPOGRAPHY_BODY1_TEXT_DECORATION = "none";
export const TYPOGRAPHY_BODY1_TEXT_TRANSFORM = "none";
export const TYPOGRAPHY_BODY2_FONT_FAMILY = "'Noto Sans', sans-serif";
export const TYPOGRAPHY_BODY2_FONT_SIZE = "16px";
export const TYPOGRAPHY_BODY2_LINE_HEIGHT = "20px";
export const TYPOGRAPHY_BODY2_FONT_WEIGHT = "300";
export const TYPOGRAPHY_BODY2_LETTER_SPACING = "-0.25px";
export const TYPOGRAPHY_BODY2_TEXT_DECORATION = "none";
export const TYPOGRAPHY_BODY2_TEXT_TRANSFORM = "none";
export const TYPOGRAPHY_BUTTON_FONT_FAMILY = "'Noto Sans', sans-serif";
export const TYPOGRAPHY_BUTTON_FONT_SIZE = "16px";
export const TYPOGRAPHY_BUTTON_LINE_HEIGHT = "20px";
export const TYPOGRAPHY_BUTTON_FONT_WEIGHT = "700";
export const TYPOGRAPHY_BUTTON_LETTER_SPACING = "-0.25px";
export const TYPOGRAPHY_BUTTON_TEXT_DECORATION = "none";
export const TYPOGRAPHY_BUTTON_TEXT_TRANSFORM = "uppercase";
export const ELEVATION_NONE = "none";
export const ELEVATION_LIGHT_LIGHT =
  "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 0px 1px 2px 0px rgba(0, 0, 0, 0.14)";
export const ELEVATION_LIGHT_LIGHT_OFFSET_X_0 = "0px";
export const ELEVATION_LIGHT_LIGHT_OFFSET_X_1 = "0px";
export const ELEVATION_LIGHT_LIGHT_OFFSET_Y_0 = "0px";
export const ELEVATION_LIGHT_LIGHT_OFFSET_Y_1 = "1px";
export const ELEVATION_LIGHT_LIGHT_BLUR_0 = "2px";
export const ELEVATION_LIGHT_LIGHT_BLUR_1 = "2px";
export const ELEVATION_LIGHT_LIGHT_SPREAD_0 = "0px";
export const ELEVATION_LIGHT_LIGHT_SPREAD_1 = "0px";
export const ELEVATION_LIGHT_LIGHT_COLOR_0 = "rgba(0, 0, 0, 0.12)";
export const ELEVATION_LIGHT_LIGHT_COLOR_1 = "rgba(0, 0, 0, 0.14)";
export const ELEVATION_LIGHT_SEMILIGHT =
  "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 0px 2px 4px 0px rgba(0, 0, 0, 0.14)";
export const ELEVATION_LIGHT_SEMILIGHT_OFFSET_X_0 = "0px";
export const ELEVATION_LIGHT_SEMILIGHT_OFFSET_X_1 = "0px";
export const ELEVATION_LIGHT_SEMILIGHT_OFFSET_Y_0 = "0px";
export const ELEVATION_LIGHT_SEMILIGHT_OFFSET_Y_1 = "2px";
export const ELEVATION_LIGHT_SEMILIGHT_BLUR_0 = "2px";
export const ELEVATION_LIGHT_SEMILIGHT_BLUR_1 = "4px";
export const ELEVATION_LIGHT_SEMILIGHT_SPREAD_0 = "0px";
export const ELEVATION_LIGHT_SEMILIGHT_SPREAD_1 = "0px";
export const ELEVATION_LIGHT_SEMILIGHT_COLOR_0 = "rgba(0, 0, 0, 0.12)";
export const ELEVATION_LIGHT_SEMILIGHT_COLOR_1 = "rgba(0, 0, 0, 0.14)";
export const ELEVATION_LIGHT_REGULAR =
  "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 0px 4px 8px 0px rgba(0, 0, 0, 0.14)";
export const ELEVATION_LIGHT_REGULAR_OFFSET_X_0 = "0px";
export const ELEVATION_LIGHT_REGULAR_OFFSET_X_1 = "0px";
export const ELEVATION_LIGHT_REGULAR_OFFSET_Y_0 = "0px";
export const ELEVATION_LIGHT_REGULAR_OFFSET_Y_1 = "4px";
export const ELEVATION_LIGHT_REGULAR_BLUR_0 = "2px";
export const ELEVATION_LIGHT_REGULAR_BLUR_1 = "8px";
export const ELEVATION_LIGHT_REGULAR_SPREAD_0 = "0px";
export const ELEVATION_LIGHT_REGULAR_SPREAD_1 = "0px";
export const ELEVATION_LIGHT_REGULAR_COLOR_0 = "rgba(0, 0, 0, 0.12)";
export const ELEVATION_LIGHT_REGULAR_COLOR_1 = "rgba(0, 0, 0, 0.14)";
export const ELEVATION_LIGHT_SEMIBOLD =
  "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 0px 8px 16px 0px rgba(0, 0, 0, 0.14)";
export const ELEVATION_LIGHT_SEMIBOLD_OFFSET_X_0 = "0px";
export const ELEVATION_LIGHT_SEMIBOLD_OFFSET_X_1 = "0px";
export const ELEVATION_LIGHT_SEMIBOLD_OFFSET_Y_0 = "0px";
export const ELEVATION_LIGHT_SEMIBOLD_OFFSET_Y_1 = "8px";
export const ELEVATION_LIGHT_SEMIBOLD_BLUR_0 = "2px";
export const ELEVATION_LIGHT_SEMIBOLD_BLUR_1 = "16px";
export const ELEVATION_LIGHT_SEMIBOLD_SPREAD_0 = "0px";
export const ELEVATION_LIGHT_SEMIBOLD_SPREAD_1 = "0px";
export const ELEVATION_LIGHT_SEMIBOLD_COLOR_0 = "rgba(0, 0, 0, 0.12)";
export const ELEVATION_LIGHT_SEMIBOLD_COLOR_1 = "rgba(0, 0, 0, 0.14)";
export const ELEVATION_LIGHT_BOLD =
  "0px 0px 8px 0px rgba(0, 0, 0, 0.12), 0px 14px 28px 0px rgba(0, 0, 0, 0.14)";
export const ELEVATION_LIGHT_BOLD_OFFSET_X_0 = "0px";
export const ELEVATION_LIGHT_BOLD_OFFSET_X_1 = "0px";
export const ELEVATION_LIGHT_BOLD_OFFSET_Y_0 = "0px";
export const ELEVATION_LIGHT_BOLD_OFFSET_Y_1 = "14px";
export const ELEVATION_LIGHT_BOLD_BLUR_0 = "8px";
export const ELEVATION_LIGHT_BOLD_BLUR_1 = "28px";
export const ELEVATION_LIGHT_BOLD_SPREAD_0 = "0px";
export const ELEVATION_LIGHT_BOLD_SPREAD_1 = "0px";
export const ELEVATION_LIGHT_BOLD_COLOR_0 = "rgba(0, 0, 0, 0.12)";
export const ELEVATION_LIGHT_BOLD_COLOR_1 = "rgba(0, 0, 0, 0.14)";
export const ELEVATION_LIGHT_EXTRABOLD =
  "0px 0px 8px 0px rgba(0, 0, 0, 0.12), 0px 32px 64px 0px rgba(0, 0, 0, 0.14)";
export const ELEVATION_LIGHT_EXTRABOLD_OFFSET_X_0 = "0px";
export const ELEVATION_LIGHT_EXTRABOLD_OFFSET_X_1 = "0px";
export const ELEVATION_LIGHT_EXTRABOLD_OFFSET_Y_0 = "0px";
export const ELEVATION_LIGHT_EXTRABOLD_OFFSET_Y_1 = "32px";
export const ELEVATION_LIGHT_EXTRABOLD_BLUR_0 = "8px";
export const ELEVATION_LIGHT_EXTRABOLD_BLUR_1 = "64px";
export const ELEVATION_LIGHT_EXTRABOLD_SPREAD_0 = "0px";
export const ELEVATION_LIGHT_EXTRABOLD_SPREAD_1 = "0px";
export const ELEVATION_LIGHT_EXTRABOLD_COLOR_0 = "rgba(0, 0, 0, 0.12)";
export const ELEVATION_LIGHT_EXTRABOLD_COLOR_1 = "rgba(0, 0, 0, 0.14)";
export const ELEVATION_DARK_LIGHT =
  "0px 0px 2px 0px rgba(0, 0, 0, 0.24), 0px 1px 2px 0px rgba(0, 0, 0, 0.28)";
export const ELEVATION_DARK_LIGHT_OFFSET_X_0 = "0px";
export const ELEVATION_DARK_LIGHT_OFFSET_X_1 = "0px";
export const ELEVATION_DARK_LIGHT_OFFSET_Y_0 = "0px";
export const ELEVATION_DARK_LIGHT_OFFSET_Y_1 = "1px";
export const ELEVATION_DARK_LIGHT_BLUR_0 = "2px";
export const ELEVATION_DARK_LIGHT_BLUR_1 = "2px";
export const ELEVATION_DARK_LIGHT_SPREAD_0 = "0px";
export const ELEVATION_DARK_LIGHT_SPREAD_1 = "0px";
export const ELEVATION_DARK_LIGHT_COLOR_0 = "rgba(0, 0, 0, 0.24)";
export const ELEVATION_DARK_LIGHT_COLOR_1 = "rgba(0, 0, 0, 0.28)";
export const ELEVATION_DARK_SEMILIGHT =
  "0px 0px 2px 0px rgba(0, 0, 0, 0.24), 0px 2px 4px 0px rgba(0, 0, 0, 0.28)";
export const ELEVATION_DARK_SEMILIGHT_OFFSET_X_0 = "0px";
export const ELEVATION_DARK_SEMILIGHT_OFFSET_X_1 = "0px";
export const ELEVATION_DARK_SEMILIGHT_OFFSET_Y_0 = "0px";
export const ELEVATION_DARK_SEMILIGHT_OFFSET_Y_1 = "2px";
export const ELEVATION_DARK_SEMILIGHT_BLUR_0 = "2px";
export const ELEVATION_DARK_SEMILIGHT_BLUR_1 = "4px";
export const ELEVATION_DARK_SEMILIGHT_SPREAD_0 = "0px";
export const ELEVATION_DARK_SEMILIGHT_SPREAD_1 = "0px";
export const ELEVATION_DARK_SEMILIGHT_COLOR_0 = "rgba(0, 0, 0, 0.24)";
export const ELEVATION_DARK_SEMILIGHT_COLOR_1 = "rgba(0, 0, 0, 0.28)";
export const ELEVATION_DARK_REGULAR =
  "0px 0px 2px 0px rgba(0, 0, 0, 0.24), 0px 4px 8px 0px rgba(0, 0, 0, 0.28)";
export const ELEVATION_DARK_REGULAR_OFFSET_X_0 = "0px";
export const ELEVATION_DARK_REGULAR_OFFSET_X_1 = "0px";
export const ELEVATION_DARK_REGULAR_OFFSET_Y_0 = "0px";
export const ELEVATION_DARK_REGULAR_OFFSET_Y_1 = "4px";
export const ELEVATION_DARK_REGULAR_BLUR_0 = "2px";
export const ELEVATION_DARK_REGULAR_BLUR_1 = "8px";
export const ELEVATION_DARK_REGULAR_SPREAD_0 = "0px";
export const ELEVATION_DARK_REGULAR_SPREAD_1 = "0px";
export const ELEVATION_DARK_REGULAR_COLOR_0 = "rgba(0, 0, 0, 0.24)";
export const ELEVATION_DARK_REGULAR_COLOR_1 = "rgba(0, 0, 0, 0.28)";
export const ELEVATION_DARK_SEMIBOLD =
  "0px 0px 2px 0px rgba(0, 0, 0, 0.24), 0px 8px 16px 0px rgba(0, 0, 0, 0.28)";
export const ELEVATION_DARK_SEMIBOLD_OFFSET_X_0 = "0px";
export const ELEVATION_DARK_SEMIBOLD_OFFSET_X_1 = "0px";
export const ELEVATION_DARK_SEMIBOLD_OFFSET_Y_0 = "0px";
export const ELEVATION_DARK_SEMIBOLD_OFFSET_Y_1 = "8px";
export const ELEVATION_DARK_SEMIBOLD_BLUR_0 = "2px";
export const ELEVATION_DARK_SEMIBOLD_BLUR_1 = "16px";
export const ELEVATION_DARK_SEMIBOLD_SPREAD_0 = "0px";
export const ELEVATION_DARK_SEMIBOLD_SPREAD_1 = "0px";
export const ELEVATION_DARK_SEMIBOLD_COLOR_0 = "rgba(0, 0, 0, 0.24)";
export const ELEVATION_DARK_SEMIBOLD_COLOR_1 = "rgba(0, 0, 0, 0.28)";
export const ELEVATION_DARK_BOLD =
  "0px 0px 8px 0px rgba(0, 0, 0, 0.24), 0px 14px 28px 0px rgba(0, 0, 0, 0.28)";
export const ELEVATION_DARK_BOLD_OFFSET_X_0 = "0px";
export const ELEVATION_DARK_BOLD_OFFSET_X_1 = "0px";
export const ELEVATION_DARK_BOLD_OFFSET_Y_0 = "0px";
export const ELEVATION_DARK_BOLD_OFFSET_Y_1 = "14px";
export const ELEVATION_DARK_BOLD_BLUR_0 = "8px";
export const ELEVATION_DARK_BOLD_BLUR_1 = "28px";
export const ELEVATION_DARK_BOLD_SPREAD_0 = "0px";
export const ELEVATION_DARK_BOLD_SPREAD_1 = "0px";
export const ELEVATION_DARK_BOLD_COLOR_0 = "rgba(0, 0, 0, 0.24)";
export const ELEVATION_DARK_BOLD_COLOR_1 = "rgba(0, 0, 0, 0.28)";
export const ELEVATION_DARK_EXTRABOLD =
  "0px 0px 8px 0px rgba(0, 0, 0, 0.24), 0px 32px 64px 0px rgba(0, 0, 0, 0.28)";
export const ELEVATION_DARK_EXTRABOLD_OFFSET_X_0 = "0px";
export const ELEVATION_DARK_EXTRABOLD_OFFSET_X_1 = "0px";
export const ELEVATION_DARK_EXTRABOLD_OFFSET_Y_0 = "0px";
export const ELEVATION_DARK_EXTRABOLD_OFFSET_Y_1 = "32px";
export const ELEVATION_DARK_EXTRABOLD_BLUR_0 = "8px";
export const ELEVATION_DARK_EXTRABOLD_BLUR_1 = "64px";
export const ELEVATION_DARK_EXTRABOLD_SPREAD_0 = "0px";
export const ELEVATION_DARK_EXTRABOLD_SPREAD_1 = "0px";
export const ELEVATION_DARK_EXTRABOLD_COLOR_0 = "rgba(0, 0, 0, 0.24)";
export const ELEVATION_DARK_EXTRABOLD_COLOR_1 = "rgba(0, 0, 0, 0.28)";
export const SIZE_TINY = "2px";
export const SIZE_SMALL = "4px";
export const SIZE_MEDIUM = "8px";
export const SIZE_LARGE = "16px";
export const SIZE_GIANT = "32px";
export const SIZE_KEY = "tiny small medium large giant";
export const SIZE_KEY_TINY = "tiny";
export const SIZE_KEY_SMALL = "small";
export const SIZE_KEY_MEDIUM = "medium";
export const SIZE_KEY_LARGE = "large";
export const SIZE_KEY_GIANT = "giant";
export const TYPOGRAPHY_KEY_HEADLINE1 = "headline1";
export const TYPOGRAPHY_KEY_HEADLINE2 = "headline2";
export const TYPOGRAPHY_KEY_HEADLINE3 = "headline3";
export const TYPOGRAPHY_KEY_HEADLINE4 = "headline4";
export const TYPOGRAPHY_KEY_HEADLINE5 = "headline5";
export const TYPOGRAPHY_KEY_HEADLINE6 = "headline6";
export const TYPOGRAPHY_KEY_BODY1 = "body1";
export const TYPOGRAPHY_KEY_BODY2 = "body2";
export const TYPOGRAPHY_KEY_BUTTON = "button";
export const ELEVATION_KEY = "light semilight regular semibold bold extrabold";
export const ELEVATION_KEY_LIGHT = "light";
export const ELEVATION_KEY_SEMILIGHT = "semilight";
export const ELEVATION_KEY_REGULAR = "regular";
export const ELEVATION_KEY_SEMIBOLD = "semibold";
export const ELEVATION_KEY_BOLD = "bold";
export const ELEVATION_KEY_EXTRABOLD = "extrabold";
export const APPEARANCE = "default outline plain soft solid";
export const APPEARANCE_DEFAULT = "default";
export const APPEARANCE_OUTLINE = "outline";
export const APPEARANCE_PLAIN = "plain";
export const APPEARANCE_SOFT = "soft";
export const APPEARANCE_SOLID = "solid";
export const VARIANT =
  "primary secondary tertiary danger warning success info highlight neutral";
export const VARIANT_PRIMARY = "primary";
export const VARIANT_SECONDARY = "secondary";
export const VARIANT_TERTIARY = "tertiary";
export const VARIANT_DANGER = "danger";
export const VARIANT_WARNING = "warning";
export const VARIANT_SUCCESS = "success";
export const VARIANT_INFO = "info";
export const VARIANT_HIGHLIGHT = "highlight";
export const VARIANT_NEUTRAL = "neutral";
export const DURATION_SHORT = "200ms";
export const DURATION_MEDIUM = "400ms";
export const DURATION_LONG = "600ms";
